import { createColumns } from './columnGroupCreator'
import { PrintFilesColumnId } from './wbFilesColumns'

import { OzonFileCell } from '../components/OzonFileCell'
import { TableDateCell } from '../components/tableCells/TableDateCell'

import { formatShipmentDatesRange } from '../common/dateTimeUtility'

import { PrintFileGroupModel } from '../server/mpsklad_core/Models/PrintFileGroupModel'

export const ozonFilesColumns =
  createColumns<PrintFilesColumnId, PrintFileGroupModel>({
    id: 'createdAt',
    title: 'Дата создания',
    sortable: true,
    CellComponent: TableDateCell
  }, {
    id: 'date',
    title: 'Дата заказа',
    sortable: true,
    accessor: formatShipmentDatesRange
  }, {
    id: 'options',
    title: 'Настройки',
    accessor: _ => [
      `Статусы: ${_.statuses}`,
      `Этикеток: ${_.labelCount}`,
      `Заказов: ${_.orderCount}`,
      `Товаров: ${_.productCount}`
    ]
  }, {
    id: 'link',
    title: 'Ссылка на файл',
    CellComponent: OzonFileCell
  })
